import api from '@/lib/axios'

export interface BrandingConfig {
  brand_name: string | null
  brand_logo_url: string | null
  brand_favicon_url: string | null
  brand_primary_color: string | null
  custom_domain: string | null
  whitelabel_enabled: boolean
}

export interface BrandingUpdateData {
  brand_name?: string | null
  brand_logo_url?: string | null
  brand_favicon_url?: string | null
  brand_primary_color?: string | null
}

export const brandingApi = {
  get: () => api.get<BrandingConfig>('/orgs/current/branding').then((r) => r.data),

  update: (data: BrandingUpdateData) =>
    api.patch<BrandingConfig>('/orgs/current/branding', data).then((r) => r.data),

  uploadLogo: (file: File) => {
    const fd = new FormData()
    fd.append('file', file)
    return api
      .post<{ brand_logo_url: string }>('/orgs/current/branding/upload-logo', fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((r) => r.data)
  },
}
